import InstallationPage from "./pages/InstallationPage.vue";

export default { InstallationPage };
